var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceReady(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 245,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1912 -1284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1914.5,
    y: 1286.5,
    width: 240,
    height: 240,
    stroke: "#000000",
    strokeWidth: 0,
    strokeMiterlimit: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Malgun Gothic,Malgun Gothic_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 46,
    transform: "matrix(1 0 0 1 1966.98 1403)"
  }, "\uC11C\uBE44\uC2A4"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Malgun Gothic,Malgun Gothic_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 46,
    transform: "matrix(1 0 0 1 1966.98 1458)"
  }, "\uC900\uBE44\uC911"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceReady);
export default __webpack_public_path__ + "static/media/service_ready.e15dc229c1582928e8d685294c1dfbf2.svg";
export { ForwardRef as ReactComponent };